import firebase from 'firebase'
var config = {
  apiKey: "AIzaSyABhBPYNoQ5L5qAtN92zu2-4TszWgE0BAw",
  authDomain: "palvelusoppari.firebaseapp.com",
  databaseURL: "https://palvelusoppari.firebaseio.com",
  projectId: "palvelusoppari",
  storageBucket: "palvelusoppari.appspot.com",
  messagingSenderId: "233162908975"
};
var fire = firebase.initializeApp(config);
export const provider = new firebase.auth.GoogleAuthProvider();
export const auth = firebase.auth();
export default fire;



// WEBPACK FOOTER //
// ./src/firebase.js